import React, { HTMLAttributes } from "react";

interface Props extends HTMLAttributes<HTMLInputElement> {
  style?: any;
  id?: string;
  color?: any;
  onChange?: any;
  value?: any;
  className?: string;
  checked?: true | false;
  disabled?: boolean;
}
const RazorToggleSlide: React.FC<Props> = ({
  style,
  id,
  color,
  onChange,
  value,
  checked,
  disabled,
}) => {
  return (
    <div className="toggle-wrap">
      <input
        type="checkbox"
        name=""
        id={`toggle-slide-${id}`}
        className="toggle-input"
        style={style}
        value={value}
        checked={checked}
        disabled={disabled}
        onChange={onChange}
      />
      <label
        htmlFor={`toggle-slide-${id}`}
        className={`toggle-label toggle-label__${color}`}
        style={
          disabled
            ? { opacity: 0.5, cursor: "not-allowed", pointerEvents: "none" }
            : undefined
        }
      >
        <span className="child-one"></span>
        <span className="child-two"></span>
      </label>
    </div>
  );
};

export default RazorToggleSlide;
